import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { InfoView } from "./views/InfoView";
import { CommonUIResourcesPackage } from "../common/resources/CommonUIResourcesPackage";
import { InfoResourcesPackage } from "./resources/InfoResourcesPackage";
import { Localization } from "../common/Localization";
import { AudioManager } from "../../audio/AudioManager";
import { InfoModel } from "./model/InfoModel";
import { InfoController } from "./controller/InfoController";

@injectable()
export class InfoScene extends Viewable<void> {
    public constructor(
        private readonly infoModel: InfoModel,
        private readonly infoController: InfoController,
        private readonly commonResources: CommonUIResourcesPackage,
        private readonly infoResources: InfoResourcesPackage,
        @inject(InjectableInterfaces.ICanvasScaler) private readonly canvasScaler: ICanvasScaler,
        private readonly localization: Localization,
        private readonly audioManager: AudioManager
    ) {
        super();
    }

    @initializer()
    public async initialize(): Promise<void> {
        const sceneCanBeClosed = new PromiseCompletionSource<void>();
        this.view = new InfoView(
            this.infoModel,
            this.infoController,
            this.commonResources,
            this.infoResources,
            this.canvasScaler,
            this.localization,
            this.audioManager,
            sceneCanBeClosed
        );
        sceneCanBeClosed.result.then(() => {
            this.operationControls.complete();
        });
    }
}